import createDataContext from './CreateDataContext'

const filterPaymentReducer = (state, action) => {
  switch (action.type) {
    case 'reset_form':
      return { ...initialState }
    case 'set_name':
      return { ...state, name: { value: action.payload } };
    case 'set_owers':
      return { ...state, owers: { value: action.payload }, touched: true };
    case 'set_payers':
      return { ...state, payers: { value: action.payload }, touched: true };
    default:
      return state;
  }
}

const setName = dispatch => (name) => {
  dispatch({ type: 'set_name', payload: name })
}

const setPayers = dispatch => (payers) => {
  dispatch({ type: 'set_payers', payload: payers })
}

const setOwers = dispatch => (owers) => {
  dispatch({ type: 'set_owers', payload: owers })
}

const resetForm = dispatch => () => {
  dispatch({ type: 'reset_form' })
}

let initialState = {
  name: { value: null, valid: null },
  payers: { value: [], valid: null },
  owers: { value: [], valid: null },
  touched: false
}

export const { Context, Provider } = createDataContext(
  filterPaymentReducer,
  {
    setName,
    setPayers,
    setOwers,
    resetForm
  },
  initialState
)
